import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DISTRIBUTION_REPORT_API } from "./apiRoutes";
interface UseGetCloseoutReportProps {
  communityId: string;
  year: string;
  filter: any;
  type: "actuals" | "plan";
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getCloseoutReport = async (communityId: string, year: string, filter: any, type: "actuals" | "plan") =>
  await axiosAuth.get(`${DISTRIBUTION_REPORT_API}/${communityId}/year/${year}/reports/closeout/${type}?${new URLSearchParams(filter).toString()}`);

const useGetCloseoutReport = ({
  queryParams,
  communityId,
  filter,
  year,
  type
}: UseGetCloseoutReportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["closeout-report", communityId, year, type],
    queryFn: () => getCloseoutReport(communityId, year, filter, type),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!queryParams?.enabled,
  });
};

export default useGetCloseoutReport;
